import React from 'react';
import ClientTable from './ClientTable';
import AdminSummary from './AdminSummary';
import FinancialSummary from './FinancialSummary';
import BalanceOutstanding from './BalanceOutstanding';

const Home = () => {
  return (
    <>
      {/* Page Content - No need for SideNav or main wrapper here */}
      <div className='col-12'>
        <ClientTable />
        <AdminSummary />
        <FinancialSummary />
        <BalanceOutstanding />
      </div>

      <div className='row col-12'>
        <div className='col-sm-12 col-md-6'>
          {/* <DataCharts/> */}
        </div>
        <div className='col-sm-12 col-md-6'>
          {/* <UserPhotoCard/> */}
        </div>
      </div>
    </>
  );
};

export default Home;